// extracted by mini-css-extract-plugin
export default {"container":"jZ-z","error":"kZ-z","disabled":"lZ-z","submit":"mZ-z","option":"nZ-z","success":"oZ-z","failure":"pZ-z"};